"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalParamChart = void 0;
var vue_1 = require("vue");
var chart_js_1 = require("chart.js");
chart_js_1.Chart.register.apply(chart_js_1.Chart, chart_js_1.registerables);
chart_js_1.Chart.defaults.font.size = 20;
chart_js_1.Chart.defaults.color = 'rgb(240, 240, 240)';
exports.GlobalParamChart = vue_1.default.component('global-param-chart', {
    data: function () {
        return {};
    },
    props: {
        game: {
            type: Object,
        },
        animation: {
            type: Boolean,
        },
    },
    methods: {
        hasEnoughData: function () {
            if (this.game.gameOptions.turmoilExtension) {
                return this.game.generation === this.game.rulingPartiesRecord.length && this.game.generation === this.game.tempRecord.length;
            }
            else {
                return this.game.generation === this.game.tempRecord.length;
            }
        },
        getLabels: function () {
            var _this = this;
            return Array.from({ length: this.game.generation }, function (_, index) { return _this.getGenerationLabel(index); });
        },
        getGenerationLabel: function (index) {
            if (this.game.gameOptions.turmoilExtension === false) {
                return "" + (index + 1);
            }
            else {
                return index + 1 + " [" + this.game.rulingPartiesRecord[index] + ']';
            }
        },
        renderChart: function () {
            var ctx = document.getElementById('paramChart');
            if (ctx !== null) {
                new chart_js_1.Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: __spreadArray(['0'], this.getLabels()),
                        datasets: [
                            {
                                label: 'Temperature',
                                data: __spreadArray([-30], this.game.tempRecord),
                                borderColor: 'rgb(153, 17, 0)',
                                backgroundColor: 'rgb(153, 17, 0)',
                                yAxisID: 'ytemp',
                                tension: 0.1,
                                pointRadius: 6,
                            },
                            {
                                label: 'Oxygen',
                                data: __spreadArray([0], this.game.oxygenRecord),
                                borderColor: 'rgb(0, 153, 0)',
                                backgroundColor: 'rgb(0, 153, 0)',
                                yAxisID: 'yoxygen',
                                tension: 0.1,
                                pointRadius: 6,
                            },
                            {
                                label: 'Ocean',
                                data: __spreadArray([0], this.game.oceanRecord),
                                borderColor: 'rgb(0, 102, 255)',
                                backgroundColor: 'rgb(0, 102, 255)',
                                yAxisID: 'yocean',
                                tension: 0.1,
                                pointRadius: 6,
                            },
                            {
                                label: 'Venus',
                                data: __spreadArray([0], this.game.venusRecord),
                                borderColor: 'rgb(170, 170, 0)',
                                backgroundColor: 'rgb(170, 170, 0)',
                                yAxisID: 'yvenus',
                                hidden: this.game.gameOptions.venusNextExtension === false,
                                tension: 0.1,
                                pointRadius: 6,
                            },
                        ],
                    },
                    options: {
                        animation: {
                            duration: this.animation ? 1000 : 0,
                            easing: 'linear',
                        },
                        plugins: {
                            title: {
                                display: true,
                                text: 'Global Parameters',
                            },
                        },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            ytemp: {
                                title: { text: 'Temperature', display: false },
                                min: -30,
                                max: 8,
                                ticks: {
                                    stepSize: 2,
                                    display: false,
                                },
                                grid: { color: 'rgb(90, 90, 90' },
                            },
                            yoxygen: {
                                title: { text: 'Oxygen', display: false },
                                min: 14,
                                max: 0,
                                ticks: {
                                    stepSize: 1,
                                    display: false,
                                },
                                grid: { color: 'rgb(90, 90, 90' },
                            },
                            yocean: {
                                title: { text: 'Ocean', display: false },
                                min: 9,
                                max: 0,
                                ticks: {
                                    stepSize: 1,
                                    display: false,
                                },
                                grid: { color: 'rgb(90, 90, 90' },
                            },
                            yvenus: {
                                title: { text: 'Venus', display: false },
                                min: 30,
                                max: 0,
                                ticks: {
                                    stepSize: 2,
                                    display: false,
                                },
                                grid: { color: 'rgb(90, 90, 90' },
                            },
                            x: {
                                title: { text: this.game.gameOptions.turmoilExtension ? 'Generation [Ruling Party]' : 'Generation', display: true },
                                offset: true,
                            },
                        },
                    },
                });
            }
        },
    },
    mounted: function () {
        this.renderChart();
    },
    template: "\n    <div class=\"score-chart-container\" v-if=\"hasEnoughData()\">\n      <div></div>\n        <canvas id=\"paramChart\"></canvas>\n      <div></div>\n    </div>\n    ",
});
//# sourceMappingURL=GlobalParamChart.js.map